// #genai
import AddCardPaymentMethod from './AddCardPaymentMethod.component';

export default AddCardPaymentMethod;
